var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Burger Menu",
    d: "M32 2H0V0h32zm0 14H0v-2h32zM0 30h32v-2H0z",
    fill: "#005051",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "33003478cf9c1afe26e030e0329f0dca.svg";
export { SvgBurgerMenu as ReactComponent };